import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const toSubmissionStatus = (submissionStatusResponse) => ({
  leadId: submissionStatusResponse.leadId,
  submissionId: submissionStatusResponse.submissionId,
  createdAt: submissionStatusResponse.createdAt,
  status: submissionStatusResponse.status,
  distribution: {
    completedAt: submissionStatusResponse.distribution.completedAt,
    distributions: submissionStatusResponse.distribution.distributions.map(
      (distribution) => ({
        subscriptionId: distribution.subscriptionId,
        supplierId: distribution.supplierId,
        distributedAt: distribution.distributedAt,
      })
    ),
  },
  selectAndConnectSubscriptions: {
    completedAt: submissionStatusResponse.selectAndConnect.completedAt,
    subscriptions: submissionStatusResponse.selectAndConnect.subscriptions.map(
      (subscription) => ({
        subscriptionId: subscription.subscriptionId,
        supplierId: subscription.supplierId,
        mvfScore: subscription.mvfScore,
        isExclusive: subscription.isExclusive,
        isConsented: subscription.isConsented,
      })
    ),
  },
});

export const GET_SUBMISSION_STATUS = gql`
  query GetSubmissionStatus($submissionId: String!) {
    getSubmissionStatus(submissionId: $submissionId) {
      leadId
      submissionId
      createdAt
      status
      selectAndConnect {
        completedAt
        subscriptions {
          subscriptionId
          supplierId
          mvfScore
          isExclusive
          isConsented
        }
      }
      distribution {
        completedAt
        distributions {
          subscriptionId
          supplierId
          distributedAt
        }
      }
    }
  }
`;

/**
 * Apollo request
 */
const getSubmissionStatusQuery = async (params) => {
  const { variables, token } = params;
  // Not ideal but this is an ongoing issue with testing and fetch policy: https://github.com/apollographql/react-apollo/issues/2867
  const fetchPolicy =
    process.env.NEXT_PUBLIC_ENV === 'test' ? undefined : 'no-cache';

  const context = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const status = await query({
      query: GET_SUBMISSION_STATUS,
      variables,
      fetchPolicy,
      context,
    });
    return toSubmissionStatus(status.data.getSubmissionStatus);
  } catch (error) {
    return null;
  }
};

export default getSubmissionStatusQuery;
